import React, {useEffect} from 'react';
import {ensureSchoolYearLoaded} from '../helpers/schoolYearLoader';

/**
 * Starts the current school-year fetch in the background.
 *
 * This component used to block the whole protected app behind a full-screen
 * spinner until `/corebase/annee` resolved, which added a backend round-trip
 * (plus the layout/page chunk downloads) to *every* boot. Only the school-period
 * config screen actually reads the year, so the request is now fired here and
 * the app renders immediately — see `helpers/schoolYearLoader`.
 *
 * Session/error handling lives in `ensureSchoolYearLoaded`: an expired session
 * still logs the user out, other failures are surfaced by the axios interceptor
 * and simply leave `user.schoolYear` null.
 */
function SchoolYearLoader({ children }: any) {
    useEffect(() => {
        // Fire and forget: navigation must never wait on this request.
        void ensureSchoolYearLoaded();
    }, []);

    return <>{children}</>;
}

export default SchoolYearLoader;
